import React from 'react'
import { ScreenshotPulse } from '../../data/howItWorks'
import { usePhoneStory } from '../../hooks/usePhoneStory'
import { revealAnimation } from './storyAnimation'

const REVEAL_MS = 450

interface ScreenshotStoryProps {
  src: string
  label: string
  isActive: boolean
  pulses?: ScreenshotPulse[]
}

/** Phone bezel with a real app screenshot for a "how it works" step; fades in the first time the step is active. */
const ScreenshotStory: React.FC<ScreenshotStoryProps> = ({ src, label, isActive, pulses }) => {
  const storyState = usePhoneStory(isActive, REVEAL_MS)

  return (
    <div aria-label={label} role="img" className="v2-phone">
      <div className="v2-phone__screen">
        <img
          alt=""
          className="v2-phone__screenshot"
          src={src}
          width={660}
          height={1435}
          loading="lazy"
          style={revealAnimation(storyState, 'v2StoryReveal', 0, REVEAL_MS)}
        />
        {pulses && pulses.length > 0 && (
          <div aria-hidden="true" className="v2-map-pulses" style={revealAnimation(storyState, 'v2StoryReveal', 0, REVEAL_MS)}>
            {pulses.map(pulse => (
              <span key={`${pulse.kind}-${pulse.x}-${pulse.y}`} className={`v2-map-pulse v2-map-pulse--${pulse.kind}`} style={{ left: `${pulse.x}%`, top: `${pulse.y}%` }}>
                <span />
                <span />
                <span />
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default ScreenshotStory
